import { render, staticRenderFns } from "./property-search.vue?vue&type=template&id=33f51445&class=rentpress-advanced-search-shortcode-property-search-wrapper&"
import script from "./property-search.vue?vue&type=script&lang=js&"
export * from "./property-search.vue?vue&type=script&lang=js&"
import style0 from "./property-search.vue?vue&type=style&index=0&id=33f51445&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports